import {
  AfterViewInit, Component, EventEmitter, OnDestroy, OnInit,
  Output,
  ViewChild, ViewContainerRef
} from '@angular/core';
import { Subscription } from 'rxjs';
import { DateUtils } from 'src/app/utils/date-utils';
import { AppComponent } from 'src/app/app.component';
import { MainComponent } from '../../main/main.component';
import { environment } from 'src/environments/environment';
import { MapComponent, MapMarker } from 'movisat-maps';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { SsoService } from 'src/app/services/sso/sso.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { PositionService } from 'src/app/services/positions/position.service';

import { MovilModel } from 'src/app/services/resources/models/movil.model';
import { PosicionModel } from 'src/app/services/positions/models/posicion.model';
import { MovilesInterface } from 'src/app/services/resources/interfaces/moviles.interface';
import { PosicionesInterface } from 'src/app/services/positions/interfaces/posiciones.interface';

import { TracksComponent } from '../../tracks/tracks.component';
import { SubflotasComponent } from '../../flota/subflotas/subflotas.component';
import { ItinerariComponent } from '../../maps-tools/itinerari/itinerari.component';
import { MovilesCercaComponent } from '../../flota/moviles-cerca/moviles-cerca.component';
import * as xlsx from 'xlsx';
import { Utils } from 'src/app/utils/utils';
import { RendererUtils } from 'src/app/utils/RendererUtils';
import { GridComponent } from 'movisat-common-gui';
import { MovilesRepository } from 'src/app/repositories/moviles.repository';
import { Grid } from 'projects/movisat-common-gui/src/lib/models/grid.model';

@Component({
  selector: 'app-moviles',
  templateUrl: './moviles.component.html',
  styleUrls: ['./moviles.component.css']
})

export class MovilesComponent implements OnInit, AfterViewInit, OnDestroy, MovilesInterface, PosicionesInterface {
  @ViewChild('movilesContainer', { read: ViewContainerRef }) public movilesContainer;
  @ViewChild('gridMovil') public gridMovil: GridComponent;

  @Output() public navegarMovilEmiter: EventEmitter<MovilModel> = new EventEmitter();
  @Output() public cargaCompleta: EventEmitter<boolean>=new EventEmitter<boolean>();

  private static instance: MovilesComponent;
  private movilesIdx = new Map<number, number>();
  private movilSelec: MovilModel = null;
  private searchText = '';
  private timerSearch = null;
  private timerInfoGeo = null;
  private orderBy = 'conectado,desc';
  private map: MapComponent;
  private subcriptionNewMovil: Subscription = null;
  private subcriptionChangeMovil: Subscription = null;
  private subcriptionPosicionReady: Subscription = null;
  private subcriptionNewPosicion: Subscription = null;
  private subcriptionChangePosicion: Subscription = null;
  private subcriptionChangeFilter: Subscription = null;
  private initialFilter = null;
  private distCerca = 0;
  private oldFilter = null;
  private dataSource = {};
  private gridRows = 0;

  protected gridConfig: Grid;
  protected showLoader: boolean = true;

  public environment = environment;
  public movilesList: MovilModel[] = [];
  public dataAdapter = new jqx.dataAdapter(this.dataSource);
  public oldSortColumn = null;
  public oldSortDirection = null;
  public initialSort = null;
  public isSorting = false;
  public langGrid = JqWidgets.getLocalization('es');
  public columns = [];

  public constructor(
    private ssoService: SsoService,
    private movilesRepo: MovilesRepository,
    private positionService: PositionService,
    private configService: ConfigService,
  ) {
    MovilesComponent.instance = this;
    this.gridConfig = {
      selectionType: "checkbox",
      isGroupable: true,
      localization: this.langGrid,
      updateFilterConditions: this.updatefilterconditions,
      filterType: this.filter,
      columnOpening: this.columnmenuopening,
      toolbar: this.createToolBar,
      sortMode:"many",
      showToolbar: true,
      cellHover: this.cellhover
    }
  }

  public async ngOnInit(): Promise<void> {
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
    // Me subscribo para saber cuando se han cargado las posiciones de todos los móviles
    this.subcriptionPosicionReady = this.positionService.subscribeOnPositionReady(this);
    // Recupero el filtro almacenado si lo hay
    this.initGrid();
    await this.getInitFilter();
    await this.getInitSort();
  }

  public ngAfterViewInit(): void {
    this.initSearchControl();
    this.initToolbarButtons();
      this.map = MainComponent.getInstance().getMap();
      if (this.map) {
        // Me subscribo a eventos del mapa
        this.map.subscribeOnMarkerClick(this, this.onMarkerClick);
        this.onPosicionesReady();
      }
  }

  public ngOnDestroy(): void {
    if (this.timerSearch === null) {
      clearInterval(this.timerSearch);
    }
    if (this.timerInfoGeo === null) {
      clearInterval(this.timerInfoGeo);
    }
    if (this.subcriptionNewMovil !== null) {
      this.subcriptionNewMovil.unsubscribe();
    }
    if (this.subcriptionChangeMovil !== null) {
      this.subcriptionChangeMovil.unsubscribe();
    }
    if (this.subcriptionPosicionReady !== null) {
      this.subcriptionPosicionReady.unsubscribe();
    }
    if (this.subcriptionNewPosicion !== null) {
      this.subcriptionNewPosicion.unsubscribe();
    }
    if (this.subcriptionChangePosicion !== null) {
      this.subcriptionChangePosicion.unsubscribe();
    }
    if (this.subcriptionChangeFilter !== null) {
      this.subcriptionChangeFilter.unsubscribe();
    }
  }

  public static getInstance(): MovilesComponent {
    return MovilesComponent.instance;
  }

  public rendexTextGeneric(row: number, columnfield: string, value: any): string {

    if (typeof value === 'string') {
      return `<div style="margin-left: 4px; margin-top: 4px;  text-align: left;"" onmouseover="this.style.backgroundColor='gray'; this.style.color='white'; this.style.position='fixed';"onmouseout="this.style.backgroundColor=''; this.style.color=''; this.style.position='';">${value}</div>`;

    } else if (typeof value === 'number') {
      return `<div style="margin-right: 4px; margin-top: 4px;  text-align: right;"><span onmouseover="this.style.backgroundColor='gray'; this.style.color='white';  this.style.position='fixed'" onmouseout="this.style.backgroundColor=''; this.style.color='';this.style.position=''"> ${value}</span></div>`;
    } else if (value instanceof Date) {

      if (columnfield === 'fecha') {
        return `<div style="margin-left: 4px; margin-top: 4px;  text-align: left;"><span onmouseover="this.style.backgroundColor='gray'; this.style.color='white';  this.style.position='fixed'" onmouseout="this.style.backgroundColor=''; this.style.color='';this.style.position=''"> ${DateUtils.formatDateTime(value, true)}</span></div>`;
      }
    }
  }

  public groupsrenderer(text?: string, group?: any, data?: any): string {
    if (group === undefined) {
      return;
    }

    const num = data?.subItems.length;
    const name = group;
    let header = '';

    if (name === true) {
      header = '(S)';
    } else if (name === false) {
      header = '(N)';
    } else {
      header = name;
    }

    return '<div style="margin-left: 4px;">' + header + ': ' + num + '</div>';
  }


  public filter = (cellValue, rowData, dataField, filterGroup, defaultFilterResult): boolean => {
    const filterColumns = ['poblacion'];
    // Obtener el valor del filtro
    const filterValue = filterGroup?.getfilters()[0]?.value;

    // Verificar si estamos filtrando por `imagenCon` o `imagenIgni`
    if (dataField === 'imagenCon' || dataField === 'imagenIgni') {
      // Seleccionar el valor correcto de `rowData` para filtrar
      const fieldToCheck = dataField === 'imagenCon' ? rowData.conectado : rowData.ignicion;

      switch (filterValue) {
        case '(S)':
          // Filtrar si el campo es igual a 1 (conectado)
          return fieldToCheck === 1;

        case '(N)':
          // Filtrar si el campo es igual a 0 (desconectado)
          return fieldToCheck === 0;

        default:
          return defaultFilterResult;
      }
    }

    // Retornar el resultado predeterminado para otros casos
    return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
  }

  public cellClass = (row: number, columnfield: any, value: any): string => {
    if (value) {
      return 'cellTooltip';
    }
    return '';
  }

  public initGrid(): void {
    this.columns = [
      {
        text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', width: 1, hidden: true
      },
      {
        text: 'CoCheck', columntype: 'checkbox', filtertype: 'textbox', datafield: 'conectado', width: 40, hidden: true,
      },
      {
        text: 'IgCheck', columntype: 'checkbox', filtertype: 'textbox', datafield: 'ignicion', width: 40, hidden: true
      },
      {
        text: 'Co', columntype: 'image', datafield: 'imagenCon', width: 25, cellsrenderer: this.imageRendererConnectado, rendered: this.createTooltip(this.translate('Conectados')),
        aggregates: [{
          'Conectados': function (aggregatedValue: number, currentValue: any, column: number, record: any): number {
            return record.conectado > 0 ? aggregatedValue + 1 : aggregatedValue;
          }
        }],
        aggregatesrenderer: function (aggregates): any {
          let renderstring = '';
          if (aggregates["Conectados"] !== undefined) {
            renderstring = '<div style="text-align: center;">' + aggregates["Conectados"] + '</div>';
          }
          return renderstring;
        }, sortable: true, filtertype: 'list',
        filteritems: ['(S)', '(N)'],
      },
      {
        text: 'Ig', columntype: 'image', datafield: 'imagenIgni', width: 25, cellsrenderer: this.imageRendererIgnicion, rendered: this.createTooltip(this.translate('Ignicion')),
        aggregates: [{
          'ConIgnicion': function (aggregatedValue: number, currentValue: any, column: number, record: any): number {
            return record.ignicion > 0 ? aggregatedValue + 1 : aggregatedValue;
          },
        }],
        aggregatesrenderer: function (aggregates): string {
          let renderstring = '';
          if (aggregates["ConIgnicion"] !== undefined) {
            renderstring += '<div style="text-align: center;">' + aggregates["ConIgnicion"];
          }
          return renderstring;
        }, sortable: true, filtertype: 'list',
        filteritems: ['(S)', '(N)'],
      },
      { text: 'Cod', columntype: 'textbox', filtertype: 'textbox', datafield: 'codigo', width: 45, align: 'center', cellsalign: 'center', hidden: true },
      {
        text: AppComponent.translate('Descripcion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 120, cellsrenderer: this.rendexTextGeneric, rendered: this.createTooltip(this.translate('Descripcion')),
        aggregates: [{
          'Total': function (aggregatedValue: number, currentValue: number): number {
            return currentValue ? aggregatedValue + 1 : aggregatedValue;
          }
        }],
        aggregatesrenderer: function (aggregates): string {
          let renderstring = '';
          if (aggregates["Total"] !== undefined) {
            renderstring = '<div style="text-align: center;">' + aggregates["Total"] + '</div>';
          }
          return renderstring;
        }, sortable: true
      },
      { text: AppComponent.translate('Subflota'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'subflota', width: 80, cellsrenderer: this.rendexTextGeneric, rendered: this.createTooltip(this.translate('Subflota')), sortable: true },
      { text: AppComponent.translate('Tipo'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'tipo', width: 35, cellsrenderer: this.rendexTextGeneric, rendered: this.createTooltip(this.translate('Tipo')), sortable: true },
      { text: AppComponent.translate('Recurso'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'recurso', width: 80, cellsrenderer: this.rendexTextGeneric, rendered: this.createTooltip(this.translate('Recurso')), sortable: true },
      { text: AppComponent.translate('Clase'), columntype: 'textbox', filtertype: 'textbox', datafield: 'clase', width: 80, cellsrenderer: this.rendexTextGeneric, rendered: this.createTooltip(this.translate('Clase')), sortable: true },
      { text: AppComponent.translate('Vel'), columntype: 'textbox', filtertype: 'textbox', datafield: 'velocidad', width: 40, align: 'center', cellsalign: 'center', cellsrenderer: RendererUtils.numberrenderer, rendered: this.createTooltip(this.translate('Velocidad')), sortable: true, },
      { text: AppComponent.translate('Desde'), columntype: 'datetimeinput', filtertype: 'date', datafield: 'fecha', width: 140, cellsrenderer: this.rendexTextGeneric, rendered: this.createTooltip(this.translate('Desde')), sortable: true },
      { text: AppComponent.translate('Direccion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'calle', width: 120, cellsrenderer: this.rendexTextGeneric, rendered: this.createTooltip(this.translate('Direccion')), sortable: true },
      { text: AppComponent.translate('Codigo_postal'), columntype: 'textbox', filtertype: 'textbox', datafield: 'codigoPostal', width: 60, cellclassname: this.cellClass, rendered: this.createTooltip(this.translate('Codigo_postal')), sortable: true },
      { text: AppComponent.translate('Poblacion'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'poblacion', width: 80, cellsrenderer: this.rendexTextGeneric, rendered: this.createTooltip(this.translate('Poblacion')), sortable: true },
      { text: AppComponent.translate('Municipio'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'municipio', width: 80, cellsrenderer: this.rendexTextGeneric, rendered: this.createTooltip(this.translate('Municipio')), sortable: true },
      { text: AppComponent.translate('Provincia'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'provincia', width: 80, cellsrenderer: this.rendexTextGeneric, rendered: this.createTooltip(this.translate('Provincia')), sortable: true },
      {
        text: AppComponent.translate('Distancia'), columntype: 'textbox', filtertype: 'textbox', datafield: 'distancia', width: 100,
        hidden: true, align: 'center', cellsalign: 'center',
        cellsrenderer: (row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any) => {
          if (value) {
            const v = value.replace(',', '.').replace('km', '').replace('m', '').replace(' ', '');
            const val = value.indexOf('km') > -1 ? Number.parseFloat(v) * 1000 : Number.parseFloat(v);
            if (val <= this.distCerca) {
              return '<div style="text-align: center; margin-top: 4px; background-color: #93fc93;">' + value + '</div>';
            }
          }
          return '<div style="text-align: center; margin-top: 4px; background-color: #F96a6a;">' + value + '</div>';
        },
        rendergridrows: (params => {
          const data = generatedata(params.startindex, params.endindex);
          return "";
        }),
      },
      {
        text: AppComponent.translate('Navegar'), datafield: 'navegar', columntype: 'button', width: 70, hidden: true, rendered: this.createTooltip(this.translate('Navegar')),
        cellsrenderer: (row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any): string => {
          return '>';
        },
        buttonclick: (row: number): void => {
          const dataRecord: any = this.gridMovil.getRowData(row);
          const movil = this.movilesList[this.movilesIdx.get(dataRecord.codigo)];
          // Notifico que quiero navegar desde este móvil a algún otro sitio
          this.navegarMovilEmiter.emit(movil);
        }, sortable: true
      },
      { text: 'Selec', columntype: 'textbox', filtertype: 'textbox', datafield: 'selec', hidden: true, width: 1 }
    ];
    this.cargaCompleta.emit(true);
  }

  // Para traducir los textos del template
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  public imageRendererConnectado(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (!rowdata) {
      return '';
    }

    const estado = rowdata.conectado > 0 ? 'conectado' : 'desconectado';

    return `<img data-estado="${estado}" style="margin-left: 4px; margin-top: 2px;" height="16" width="16" src="assets/images/${estado}.png" />`;
  }

  public imageRendererIgnicion(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (!rowdata) {
      return '';
    }

    const estado = rowdata.ignicion > 0 ? 'encendido' : 'apagado';
    const imagePath = rowdata.ignicion > 0 ? 'assets/images/ignicion1.png' : 'assets/images/ignicion0.png';

    return `<img data-estado="${estado}" data-field="ignicion" style="margin-left: 4px; margin-top: 2px;" height="16" width="16" src="${imagePath}" />`;
  }


  public cellhover(cellhtmlElement ?: any): void {
  if(!cellhtmlElement) {
      return;
    }

    const imageConectado = cellhtmlElement?.parentElement?.querySelector('[columnindex="4"]').firstChild;
    const imageIgnicion = cellhtmlElement?.parentElement?.querySelector('[columnindex="5"]').firstChild;

  if(imageConectado) {
      const estadoConectado = imageConectado.dataset.estado;
      const contentConectado = estadoConectado === 'conectado' ? AppComponent.translate('Con_conexion') : AppComponent.translate('Sin_conexion');
      MovilesComponent.getInstance().showTooltip(imageConectado, contentConectado);
    }

    if(imageIgnicion) {
      const estadoIgnicion = imageIgnicion.dataset.estado;
      const contentIgnicion = estadoIgnicion === 'encendido' ? AppComponent.translate('Con_ignicion') : AppComponent.translate('Sin_ignicion');
      MovilesComponent.getInstance().showTooltip(imageIgnicion, contentIgnicion);
    }
  }


  private showTooltip(element: any, content: string): void {
    // Crear instancia de jqxTooltip
    const options = {
      content: content,
      theme: environment.tema,
      width: 'auto',
      height: 'auto',
      position: 'mouse',
      autoHide: true,
    };
    jqwidgets.createInstance(element, 'jqxTooltip', options);
  }


  public onMarkerClick(component: any, marker: MapMarker): void {
    // Compruebo que se trata de un móvil
    if (marker.dataModel.hasOwnProperty('Ignicion')) {
      // Busco el elemento en el grid y lo selecciono
      const rows = component.gridMovil.getRows();
      if (rows) {
        rows.forEach((row, i) => {
          if (row.id === marker.dataModel.MovilId) {
            component.gridMovil.ensureRowVisible(i);
            const event = {
              args: {
                rowindex: row.dataindex ? row.dataindex : row.boundindex,
                fromCarto: true
              }
            }
            component.onRowClick(event);
          }
        });
      }
    }
  }

  // Inicializa el control de búsqueda de la cabecera
  public initSearchControl(): void {
    const searchControl = document.getElementById('searchControl');
    if (searchControl) {
      searchControl.addEventListener('input', (event: any) => {
        this.searchText = event.target.value.toUpperCase();
      });

      let lastSearch = '';
      this.timerSearch = setInterval(() => {
        if (this.searchText !== lastSearch) {
          lastSearch = this.searchText;
          const searchUpper = this.searchText.toUpperCase();

          this.movilesList.forEach(movil => {
            if (
              ("" + movil.Codigo).includes(searchUpper) ||
              (movil.Nombre?.toUpperCase() || "").includes(searchUpper) ||
              (movil.Matricula?.toUpperCase() || "").includes(searchUpper) ||
              (movil.ConjuntoVehiculo?.Recurso?.Nombre?.toUpperCase() || "").includes(searchUpper) ||
              (movil.Clase?.Nombre?.toUpperCase() || "").includes(searchUpper) ||
              (movil.Subflota?.Nombre?.toUpperCase() || "").includes(searchUpper) ||
              ("" + movil.ultimaPos?.Velocidad).toUpperCase().includes(searchUpper) ||
              (movil.ultimaPos?.Fecha && DateUtils.formatDateTimeShort(movil.ultimaPos.Fecha, true).toUpperCase().includes(searchUpper)) ||
              (movil.ultimaPos?.Localizacion?.District?.toUpperCase() || "").includes(searchUpper) ||
              (movil.ultimaPos?.Localizacion?.Street?.toUpperCase() || "").includes(searchUpper) ||
              (movil.ultimaPos?.Localizacion?.StreetNumber?.toUpperCase() || "").includes(searchUpper) ||
              (movil.ultimaPos?.Localizacion?.PostalCode?.toUpperCase() || "").includes(searchUpper) ||
              (movil.ultimaPos?.Localizacion?.Locality?.toUpperCase() || "").includes(searchUpper) ||
              (movil.ultimaPos?.Localizacion?.AdministrativeArea2?.toUpperCase() || "").includes(searchUpper) ||
              ("" + movil.distancia).toUpperCase().includes(searchUpper)
            ) {
              movil.selec = 'selec';
            } else {
              movil.selec = '';
            }
          });

          const filters = this.gridMovil.getFilterInformation();
          const existingFilter = filters.find(s => s.datafield === 'selec');
          if (existingFilter) {
            this.gridMovil.removeFilter('selec', false);
          }

          const filtergroup = new jqx.filter();
          filtergroup.addfilter(1, filtergroup.createfilter('stringfilter', 'selec', 'equal'));
          this.gridMovil.addFilter('selec', filtergroup);
          this.gridMovil.applyFilters();
          this.gridMovil.updateBoundData();
        }
      }, 1000);
    }
  }

  public onGridRendered(event?): void {
    if (this.gridMovil === undefined) {
      return;
    }
    try {
      const orderParameters = this.orderBy.split(',');
      if (this.gridMovil && this.movilesList && this.movilesList.length > 0) {
        this.isSorting = true; // Antes de ordenar, marca que estás en medio de una ordenación

        // Ordenar por 'conectado' primero
        this.gridMovil.sortBy(orderParameters[0], orderParameters[1]);

        // Si el usuario ha establecido un campo y una dirección de ordenación
        if (orderParameters.length > 2) {
          this.gridMovil.sortBy(orderParameters[2], orderParameters[3]);
        }

        this.isSorting = false; // Una vez que la ordenación se completa, desmarca que estás en medio de una ordenación
      }

      if (this.initialFilter) {
        this.setStoredFilter();
      }
      // Si no está el reproductor de ruta abierto me aseguro que todos los móviles del
      // grid se visualizan en en la cartogafía y quito los que no están visibles
      if (!TracksComponent.instance) {
        const rowsVisibles = this.gridMovil.getRows();
        if (rowsVisibles) {
          const movilesVisibles = new Map<number, number>();
          rowsVisibles.forEach(row => {
            movilesVisibles.set(row.codigo, row.codigo);
          });
          if (this.movilesList) {
            this.movilesList.forEach(movil => {
              if (movil.marker) {
                movil.marker.setVisible(movilesVisibles.get(movil.Codigo) !== undefined);
              }
            });
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
    finally {
      this.movilesRepo.recordCountMovilesUpdate(this.gridMovil.getRows().length);
    }
  }

  onRowClick(event: any) {
    const rowSel = this.gridMovil.getSelectedRowIndexes();
    if (rowSel && rowSel.length < 2) {
      this.gridMovil.clearSelection();
      this.gridMovil.selectRow(event.args.rowindex);
    }
    this.movilSelec = this.movilesList[event.args.rowindex];
    if (this.movilSelec.marker !== undefined) {
      if (!event.args.fromCarto) {
        this.movilSelec.marker.map.setCenter(this.movilSelec.marker.position);
        this.movilSelec.marker.animate(2850);
      }
    }
  }



  // Cuando se crea un móvil nuevo
  public onNewMovil(movil: MovilModel): void {
    // Añado el móvil a la lista
    this.movilesIdx.set(movil.Codigo, this.movilesList.length);
    this.movilesList.push(movil);
  }

  // Cuando cambia la información de un móvil
  public onChangeMovil(movil: MovilModel): void {
    // Actualizo los datos del móvil en la lista
    this.movilesList[this.movilesIdx.get(movil.Codigo)] = movil;
  }

  // Cuando se han terminado de recuperar las posiciones de todos los móviles
  public async onPosicionesReady(): Promise<void> {
    // Cargo la lista de móviles y me subscribo para recibir los cambios
    await this.getMoviles();
    this.subcriptionNewMovil = this.movilesRepo.subscribeNewMoviles(this);
    this.subcriptionChangeMovil = this.movilesRepo.subscribeChangeMoviles(this);
    this.subcriptionChangeFilter = this.movilesRepo.changeFilterEmiter.subscribe(async () => {
      await this.getMoviles();
      this.gridMovil.updateBoundEmpty();
      MainComponent.getInstance().createMarkerPos();
    });
    // Me subscribo para recibir los cambios en las posiciones de los móviles
    this.subcriptionNewPosicion = this.positionService.subscribeNewPosition(this);
    this.subcriptionChangePosicion = this.positionService.subscribeChangePosition(this);
    // Actualizo el grid cada x tiempo para que se actualicen la información geográfica
    this.timerInfoGeo = setInterval(() => {
      this.gridMovil.updateBoundData();
    }, environment.refresInfoGeoInterval);

  }

  public renderDate(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (value) {
      let date = new Date(value);
      return '<div class="jqx-grid-cell-left-align" style="margin-top: 4px; text-align: left">' + DateUtils.formatDateTimeShort(date, true) + '</div>';
    }
  }

  public async getMoviles(): Promise<void> {
    try {
      this.movilesRepo.fetch().subscribe((result) => {
        this.movilesList = result;

        result.forEach((movil, index) => {
          this.movilesIdx.set(movil.Codigo, index);
        });

        this.dataSource = {
          datatype: 'json',
          datafields: [
            { name: 'id', map: 'Codigo' },
            { name: 'conectado', map: 'Conectado' },
            { name: 'ignicion', map: 'Ignicion' },
            { name: 'codigo', map: 'Codigo' },
            { name: 'nombre', map: 'Nombre' },
            { name: 'subflota', map: 'Subflota>Nombre' },
            { name: 'tipo', map: 'TipoMovil>Acronimo' },
            { name: 'recurso', map: 'ConjuntoVehiculo>Recurso>Nombre' },
            { name: 'clase', map: 'Clase>Nombre' },
            { name: 'velocidad', map: 'ultimaPos>Velocidad' },
            { name: 'fecha', type: 'date', map: 'ultimaPos>Fecha' },
            { name: 'distancia', map: 'distancia' },
            { name: 'calle', map: 'ultimaPos>Localizacion>Street' },
            { name: 'numero', map: 'ultimaPos>Localizacion>StreetNumber', type: 'number' },
            { name: 'codigoPostal', map: 'ultimaPos>Localizacion>PostalCode', type: 'string' },
            { name: 'poblacion', map: 'ultimaPos>Localizacion>District', type: 'string' },
            { name: 'municipio', map: 'ultimaPos>Localizacion>Locality' },
            { name: 'provincia', map: 'ultimaPos>Localizacion>AdministrativeArea2' },
            { name: 'selec', map: 'selec' }
          ],
          localdata: result,
        };

        this.movilesList.forEach(movil => {
          if (movil.ultimaPos?.Localizacion) {
            movil.ultimaPos.Localizacion.Street =
              (movil.ultimaPos.Localizacion.Street || '') + ' ' +
              (movil.ultimaPos.Localizacion.StreetNumber || '');
          }
        });

        this.dataAdapter = new jqx.dataAdapter(this.dataSource);
        this.gridMovil.columnMenuOpening(this.columnmenuopening);
        this.gridMovil.updateBoundData();
        this.movilesRepo.recordCountMovilesTotal(result.length);
        this.gridMovil.updateBoundData();

        this.showLoader = false;
      });
    } catch (error) {
      console.error(error);
    }
  }

  public updatefilterconditions = (type: string, defaultconditions: any): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  // Ajusto el menu del filtro en funcion de la posicion
  public columnmenuopening = (menu: any, datafield: any, height: any): void => {
    if (menu && menu[0]) {
      const menuElement = <HTMLElement>document.getElementById(menu[0].id);
      const areaGestion = <HTMLElement>document.getElementById('gridMoviles').children[0].children[0];
      const column = MovilesComponent.instance.gridMovil.getColumn(datafield)['element'];
      let menuTop = 0;

      /* En caso de que vaya a sobresalir por debajo de la pantalla lo ajusto hacia arriba */
      if (height > areaGestion.offsetHeight) {
        menuTop = height - areaGestion.offsetHeight + 100;

        menuElement.parentElement.style.top = '-' + menuTop + 'px';
      }

      /* Ajuste del menu para que se vea el boton de filtro en el grid */
      setTimeout(() => {
        const columnPos = column.offsetLeft + column.offsetWidth;
        const menuWidth = menuElement.offsetWidth;

        if (columnPos + menuWidth >= areaGestion.offsetWidth) {
          menuElement.parentElement.style.left = '-20px';
        } else {
          menuElement.parentElement.style.left = '20px';
        }
        /*
          Recoge los desplegables del menu del filtro
          y le añade un evento al hacer click
        */
        const dropDownFilterList = document.getElementsByClassName('jqx-dropdownlist');
        const listBox = document.getElementsByClassName('jqx-listbox-container');

        const arrListFilter: any = Array.from(dropDownFilterList);
        const arrListBox: any = Array.from(listBox);

        arrListFilter.forEach((element, idx) => {
          element.addEventListener("click", function () {
            /*
              Si el desplegable va a sobresalir le ajusta el top
              para que aparezca por encima del boton desplegable
            */
            if (document.body.offsetHeight < (arrListBox[idx].offsetTop + arrListBox[idx].offsetHeight)) {
              arrListBox[idx].style.top = (arrListBox[idx].offsetTop - (arrListBox[idx].offsetHeight + 10)) + 'px';
            }
          });
        });

        /*
          Recoge los desplegable de calendario
          y añade un evento al hacer click
        */
        const calendarButton = document.getElementsByClassName('jqx-icon-calendar');
        const listCalendar = document.getElementsByClassName('jqx-calendar-container');

        const arrcalendarButton: any = Array.from(calendarButton);
        const arrlistCalendar: any = Array.from(listCalendar);

        arrcalendarButton.forEach((btn, idx) => {
          btn.parentElement.addEventListener("click", function () {
            /*
              Si el desplegable va a sobresalir le ajusta el top
              para que aparezca por encima del boton desplegable
            */
            if (document.body.offsetHeight < (arrlistCalendar[idx].offsetTop + arrlistCalendar[idx].offsetHeight)) {
              arrlistCalendar[idx].style.top = (arrlistCalendar[idx].offsetTop - (arrlistCalendar[idx].offsetHeight + 40)) + 'px';
            }
          })
        });
      }, 50)
    }
  };

  onNewPosicion(posicion: PosicionModel) {
  }

  onChangePosicion(posicion: PosicionModel) {
  }

  private createTooltip = (content: string) => {
    return (columnHeaderElement?: any) => {
      if (!columnHeaderElement) {
        return;
      }
      const jqElement = columnHeaderElement[0]?.parentElement;
      if (!jqElement) {
        return;
      }
      const options = {
        content: content,
        theme: environment.tema,
        width: 'auto',
        height: 'auto',
        position: 'mouse',
        autoHide: true,
      };
      jqwidgets.createInstance(jqElement, 'jqxTooltip', options);
    };
  };

  // Crea los componentes de la cabecera
  public createToolBar(statusbar: any): void {
    if (statusbar[0] !== undefined) {
      // Añado el control de búsqueda a la cabecera
      const toolbarContainer = document.createElement('div');
      toolbarContainer.style.cssText = 'overflow: hidden; position: relative; margin-left: 4px; margin-top: 0px';
      const searchControl: any = document.createElement('div');
      searchControl.id = 'searchControl';
      searchControl.style.cssText = `
        float: left;
        background-color: white;
        background-image: url('../assets/images/search.png');
        background-repeat: no-repeat;
        background-position: 4px center;
        background-size: 18px;
        display: flex;
        align-items: center;
        width: 206px;
        margin-top: 2px;
        padding-top: 2px;
        padding-left: 28px;
        height: 25px;
        border: 1px solid rgba(0, 0, 0, 0.5);
        border-radius: 3px;
        overflow: hidden;
      `;
      searchControl.innerHTML = '<input type="text" style="border: 0;width: 100%; outline: none;" (keydown.enter)="$event.preventDefault()" ' +
        'placeholder="' + AppComponent.translate('Buscar') + '..." autocorrect = "off" autocapitalize = "off" spellcheck = "off">';
      toolbarContainer.appendChild(searchControl);
      // Creo el botón para reproducir rutas
      const btnSubflotas: any = document.createElement('div');
      btnSubflotas.id = 'btnSubflotas';
      btnSubflotas.style.cssText = 'float: left; height: 25px; width: 105px; padding-left: 3px; padding-top: 2px;';
      btnSubflotas.innerHTML = `
        <button type="submit" style="width: 100px; height: 25px; align-items: center; cursor: pointer;">
        <div style="float: right; padding-top: 2px;">`+ AppComponent.translate('Subflotas') + `</div>
        <img style="float: left; height: 18px; width: 18px;" src="../assets/images/subflota.png" /></button>
      `;
      toolbarContainer.appendChild(btnSubflotas);
      // Creo el botón para reproducir rutas
      const btnRutaControl: any = document.createElement('div');
      btnRutaControl.id = 'btnRecorrido';
      btnRutaControl.style.cssText = 'float: left; height: 25px; width: 110px; padding: 2px;';
      btnRutaControl.innerHTML = `
        <button type="submit" style="width: 110px; height: 25px; align-items: center;cursor: pointer;">
        <div style="float: right; padding-top: 2px;">`+ AppComponent.translate('Recorridos') + `</div>
        <img style="float: left; height: 18px; width: 18px;" src="../assets/images/route.png" /></button>
      `;
      toolbarContainer.appendChild(btnRutaControl);

      // Creo el botón para móviles cercanos
      const btnMovilesCerca: any = document.createElement('div');
      btnMovilesCerca.id = 'btnMovilesCerca';
      btnMovilesCerca.style.cssText = 'float: left; height: 25px; width: 75px; margin-left: 4px; padding: 2px;';
      btnMovilesCerca.innerHTML = `
        <button type="submit" style="width: 75px; height: 25px; align-items: center;cursor: pointer;">
        <div style="float: right; padding-top: 2px;">`+ AppComponent.translate('Cerca') + `</div>
        <img style="float: left; height: 18px; width: 18px;" src="../assets/images/radar.png" /></button>
      `;
      toolbarContainer.appendChild(btnMovilesCerca);
      // Creo el botón para itinerarios
      const btnItinerari: any = document.createElement('div');
      btnItinerari.id = 'btnItinerari';
      btnItinerari.style.cssText = 'float: left; height: 25px; width: 110px; margin-left: 4px; padding: 2px;';
      btnItinerari.innerHTML = `
        <button type="submit" style="width: 110px; height: 25px; align-items: center;cursor: pointer;">
        <div style="float: right; padding-top: 2px;">`+ AppComponent.translate('Itinerarios') + `</div>
        <img style="float: left; height: 18px; width: 18px;" src="../assets/images/itinerary.png" /></button>
      `;
      toolbarContainer.appendChild(btnItinerari);
      // añado el boton exportar a excel
      const btnExportar: any = document.createElement('div');
      btnExportar.id = 'btnExportarMoviles';
      btnExportar.style.cssText = 'float: right; height: 25px;  padding: 2px;';
      btnExportar.innerHTML = `
        <button type="submit" class='button' title='`+ AppComponent.translate('Exportar') + `' style="width: 35px; height: 25px; align-items: center; cursor: pointer;">
        <div style="float: right; padding-top: 2px;"></div>
        <i class="fa fa-file-excel fa-lg"></i></button>
      `;
      toolbarContainer.appendChild(btnExportar);
      statusbar[0].appendChild(toolbarContainer);
    }
  }

  //devuelve una lista de elementos moviles que es llamado en el componente track.ts
  public getListMoviles(): MovilModel[] {
    const movilesSelec: MovilModel[] = [];
    const rowsSelec = this.gridMovil.getSelectedRowIndexes();
    if (rowsSelec && rowsSelec.length > 0) {
      if (rowsSelec.length < 6) {
        rowsSelec.forEach(rowIndex => {
          movilesSelec.push(this.movilesList[rowIndex]);
        });
      }
      else {
        MainComponent.getInstance().showWarning('ATENCION', 'Cinco_moviles_maximo', 3000);
        return null
      }
    }
    return movilesSelec;
  }

  // Inicializa los botones de la cabecera
  public initToolbarButtons(): void {
    const btnRoute = document.getElementById('btnRecorrido');
    if(btnRoute) {
      btnRoute.addEventListener('click', (event: any) => {
        // Sólo puede haber un reproductor abierto
        // if (!TracksComponent.instance) {
        // Recupero los móviles selecionados
        const rowsSelec = this.gridMovil.getSelectedRowIndexes();
        if (rowsSelec && rowsSelec.length > 0) {
          if (rowsSelec.length < 6) {
            const movilesSelec: MovilModel[] = [];
            rowsSelec.forEach(rowIndex => {
              movilesSelec.push(this.movilesList[rowIndex]);

            });
            // Obtengo las filas filtradas para que el reproductor pueda ocultar y luego volver a poner
            // visibles sólo los móviles filtrados
            const movilesVisibles: MovilModel[] = [];
            let rowsVisibles = this.gridMovil.getRows();
            if (rowsVisibles) {
              rowsVisibles.forEach(row => {
                movilesVisibles.push(this.movilesList[this.movilesIdx.get(row.codigo)]);
              });
            }
            // Creo el componente y le paso los móviles seleccionados, también le paso los filtrados en ese momento
            const component = this.movilesContainer.createComponent(TracksComponent);
            component.instance.init(component, movilesSelec, movilesVisibles);
          } else {
            MainComponent.getInstance().showWarning('ATENCION', 'Cinco_moviles_maximo', 3000);
          }
        } else {
          MainComponent.getInstance().showInfo('ATENCION', 'Seleccione_movil', 3000);
        }
      });
    }
    const btnSubflota = document.getElementById('btnSubflotas');
    if(btnSubflota) {
      btnSubflota.addEventListener('click', (event: any) => {
        const component = this.movilesContainer.createComponent(SubflotasComponent);
        component.instance.init(component);
      });
    }
    const btnMovilesCerca = document.getElementById('btnMovilesCerca');
  if(btnMovilesCerca) {
      btnMovilesCerca.addEventListener('click', (event: any) => {
        const component = this.movilesContainer.createComponent(MovilesCercaComponent);
        component.instance.init(component, 0);
      });
    }
    const btnItinerari = document.getElementById('btnItinerari');
    if (btnItinerari) {
      btnItinerari.addEventListener('click', (event: any) => {
        if(ItinerariComponent && ItinerariComponent._this && ItinerariComponent._this.ventana) {
          return;
        }

        const component = this.movilesContainer.createComponent(ItinerariComponent);
        component.instance.init(component, 0);
      });
    }
    //boton exportar
    const btnExportar = document.getElementById('btnExportarMoviles');
    if (btnExportar) {
      btnExportar.addEventListener('click', (event: any) => {
        if (this.gridMovil.getRows().length === 0) {
          return MainComponent.getInstance().showWarning('ATENCION', this.translate('No_existen_datos'), 2000);
        } else {
          const datosExportados = this.gridMovil.getRows().map(element => ({
            [this.translate('Conectados')]: element.conectado === 1 ? this.translate('SI') : this.translate('NO'),
            [this.translate('Ignicion')]: element.ignicion === 1 ? this.translate('SI') : this.translate('NO'),
            [this.translate('Nombre')]: element.nombre || '',
            [this.translate('Subflota')]: element.subflota || '',
            [this.translate('Tipo')]: element.tipo || '',
            [this.translate('Recurso')]: element.recurso || '',
            [this.translate('Clase')]: element.clase || '',
            [this.translate('Velocidad')]: element.velocidad ?? '',
            [this.translate('Fecha')]: element.fecha ? DateUtils.formatDateTimeShort(element.fecha, true) : '',
            [this.translate('Distancia')]: element.distancia ?? '',
            [this.translate('Calle')]: element.calle || '',
            [this.translate('Numero')]: element.numero ?? '',
            [this.translate('Codigo_postal')]: element.codigoPostal ?? '',
            [this.translate('Poblacion')]: element.poblacion || '',
            [this.translate('Municipio')]: element.municipio || '',
            [this.translate('Provincia')]: element.provincia || '',
          }));

          const ws = xlsx.utils.json_to_sheet(datosExportados);
          this.generateAutofilterHeader(ws);
          const wb = xlsx.utils.book_new();
          xlsx.utils.book_append_sheet(wb, ws, 'Hoja1');
          xlsx.writeFile(wb, DateUtils.formatDateAMDhms(new Date()) + '_' + this.translate('Moviles') + '.xlsx');
          this.gridMovil.showColumn('imagenCon');
          this.gridMovil.showColumn('imagenIgni');
        }
      });

    }
  }

  public generateAutofilterHeader(sheet): void {
    // Añade filtro a todas las casillas.
    sheet['!autofilter'] = { ref: sheet['!ref'] };
  }

  // Cando se crea un filtro
  public async onChangeFilter(event: any): Promise<void> {
    this.initialFilter = null;
    let filter = null;
    // Si el primer filtro es el de la búsqueda busco el siguiente filtro
    let columnFilter = event.args.filters[0] ? event.args.filters[0].datafield : '';
    if (columnFilter === 'selec') {
      if (event.args.filters[1]) {
        // Si hay un segundo filtro es por que se han filtrado por alguna columna
        columnFilter = event.args.filters[1].datafield
        filter = event.args.filters[1].filter.getfilters();
      }
    } else {
      filter = event.args.filters[0] ? event.args.filters[0].filter.getfilters() : null;
    }
    // Si ha cambiado el filtro
    if (this.oldFilter !== filter) {
      this.oldFilter = filter;
      // Si no hay filtro pongo la variable en blanco
      if (!filter) {
        // Guardo la variable de configuración en blanco
        this.configService.setUsuEmpApp('moviles-filters', '');
      } else {
        const config = {
          column: columnFilter,
          filters: filter
        }
        // Guardo la variable de configuración con los datos del filtro
        this.configService.setUsuEmpApp('moviles-filters', JSON.stringify(config));
      }
      // Para que se repinten los cluster
      this.onGridRendered();
    }
  }

  public setStoredFilter(): void {
    // Recupero los datos del filtro guardado y los aplico
    const filtergroup = new jqx.filter();
    if (this.initialFilter && this.initialFilter.filters) {
      this.initialFilter.filters.forEach(elem => {
        const filter = filtergroup.createfilter(elem.type, elem.value, elem.condition);
        filtergroup.addFilter(elem.operator, filter);
      });
      this.gridMovil.addFilter(this.initialFilter.column, filtergroup);
      this.gridMovil.applyFilters();
      this.initialFilter = null;
    }
  }

  // Recupero el filtro guardado si lo hay
  public async getInitFilter(): Promise<void> {
      this.initialFilter = await this.configService.getUsuEmpApp('moviles-filters', null);
      if (this.initialFilter) {
        this.initialFilter = JSON.parse(this.initialFilter);
      }
    }

  public async getInitSort(): Promise<void> {
      const storedSort: any = await this.configService.getUsuEmpApp('moviles-sort', null);
      if (storedSort) {
        const sortConfig = JSON.parse(storedSort);
        if (sortConfig.column === null) {
          this.setOrderBy('nombre', 'desc');
        } else {
          this.setOrderBy(sortConfig.column, sortConfig.direction);
        }
      }
    }

  public onSort(event: any): void {
    if (this.isSorting) {
      // Si estamos en medio de una ordenación, no hagas nada
      return;
    }
    // Asume que `event.args.sortinformation.sortcolumn` es el campo de orden y `event.args.sortinformation.sortdirection.ascending` indica si es ascendente
    const userField = event.args.sortinformation.sortcolumn;
    const userDirection = event.args.sortinformation.sortdirection.ascending ? 'asc' : 'desc';

    // si se quita la ordenación, establece el orden predeterminado
    if (event.args.sortinformation.sortdirection.ascending === false && event.args.sortinformation.sortdirection.descending === false) {
      this.orderBy = 'conectado,desc';
      this.onGridRendered();
      return;
    }

    // Actualizar orderBy para mantener 'conectado' como primer criterio de orden
    this.setOrderBy(userField, userDirection);

    // Crea la configuración de ordenación
    const sortConfig = {
      column: userField,
      direction: userDirection
    }
    // Guarda la configuración de ordenación
    this.configService.setUsuEmpApp('moviles-sort', JSON.stringify(sortConfig));

    // Rehacer el enlace de datos después de cambiar la orden
    this.onGridRendered();
  }

  public setOrderBy(field: string, direction: string): void {
    this.orderBy = `conectado,desc,${field},${direction}`;
  }

  public async refreshGrid(): Promise<void> {
    setTimeout(() => {
      this.gridMovil.updateBoundData();
      this.gridMovil.ensureRowVisible(0);
    }, 500);
  }

  public async orderGridBy(column: string, order: string): Promise<void> {
    setTimeout(() => {
      this.orderBy = column + ',' + order;
      this.gridMovil.updateBoundCell();
      this.gridMovil.ensureRowVisible(0);
    }, 500);
  }

  // Permite visualizar u ocultar columnas del grid
  public showColumnGrid(column: string, show: boolean): void {
    if (show) {
      this.gridMovil.showColumn(column);
    } else {
      this.gridMovil.hideColumn(column);
    }
  }

  // Permite asignar la distancia a la que se buscan móviles cerca
  public setDistanciaCerca(distancia: number): void {
    this.distCerca = distancia;
  }
}
